import { post, unAuthGet } from "../Services/api.service";
import { Paths } from "../Services/EndPoints";

// Cookie consent stored under this localStorage key. Absent = "no consent yet".
const KEY = "cookieConsent";
export const CONSENT_VERSION = 1;

// Returns the stored consent object, or null if the user hasn't chosen yet.
export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function hasConsent() {
  return getConsent() !== null;
}

// essential is always allowed. Everything else is ON BY DEFAULT: there is no
// consent banner, so "nothing stored" means "never opted out", not "not asked
// yet". An explicit stored false (from /cookie-preferences) still wins -- that
// page is the only way to turn a category off, and it must keep working.
export function isAllowed(category) {
  if (category === "essential") return true;
  const c = getConsent();
  if (!c) return true;
  return c[category] !== false;
}

// Writes the choice to localStorage (source of truth for the pixel gate) and
// notifies pwa.js + the banner. Does NOT hit the server.
function writeLocal(prefs) {
  const value = {
    analytics: !!prefs.analytics,
    advertising: !!prefs.advertising,
    functional: !!prefs.functional,
    version: CONSENT_VERSION,
    ts: Date.now(),
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch (e) {
    /* ignore storage failures */
  }
  window.dispatchEvent(new Event("consentchange"));
  return value;
}

export function setConsent(prefs) {
  const value = writeLocal(prefs);
  saveConsentToServer(value);
  return value;
}

// Best-effort server sync — never block or throw into the UI.
// Payload per backend: essential is always true.
function saveConsentToServer(value) {
  if (!Paths.save_consent) return;
  try {
    post(Paths.save_consent, {
      essential: true,
      analytics: value.analytics,
      advertising: value.advertising,
      functional: value.functional,
    }).catch(() => {});
  } catch (e) {
    /* ignore */
  }
}

// Hydrate consent from the server on first visit (before showing the banner).
// Returns true if a stored record was found + applied locally. Best-effort:
// on any miss/error we return false so the banner asks the user.
export async function fetchServerConsent() {
  if (hasConsent() || !Paths.get_consent) return hasConsent();
  try {
    const res = await unAuthGet(Paths.get_consent);
    const d = res?.data;
    if (
      d &&
      (d.analytics !== undefined ||
        d.advertising !== undefined ||
        d.functional !== undefined)
    ) {
      // writeLocal fires consentchange (re-gates pixel + hides banner); no re-POST.
      writeLocal(d);
      return true;
    }
  } catch (e) {
    /* ignore — treat as no consent so the banner shows */
  }
  return false;
}
